<template>
	<div class="fatal-error" v-if="show">
		<el-alert title="未知错误" type="error" :description="fatalErrorText" show-icon style="width: 80%;margin: 0 auto;">
		</el-alert>
	</div>
</template>

<script>
	export default {
		name: 'FatalError',
		props: {
			show:{
				type:Boolean,
				required:false
			},
			fatalErrorText:{
				type:String,
				required:false
			}
		}
	}
</script>

<style scoped lang='less'>
	.fatal-error {
		display: block;
		margin-top: 50px;
	}
</style>


// WEBPACK FOOTER //
// src/components/Common/FatalError.vue